import React, { useState, useLayoutEffect, useContext, useEffect } from "react";
import { motion } from "framer-motion";
import { useHistory } from "react-router-dom";

// components
import { Header, Sidebar } from "src/components/Dashboard/components";

// context
import { AdminAuthContext } from "src/context/AdminAuthContext";

// styles
import styles from "./Dashboard.module.scss";

const Dashboard = ({ children }) => {
  const { isAuthenticated } = useContext(AdminAuthContext);

  const history = useHistory();
  const [isOpen, setIsOpen] = useState(null);
  const [verified, setVerified] = useState(false);

  useLayoutEffect(() => {
    checkWidth();
  }, []);

  useEffect(() => {
    if (!isAuthenticated) {
      history.push("/admin-login");
    } else {
      setVerified(true);
      console.log("you are successfully authenticated");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  const toggle = () => setIsOpen(!isOpen);

  const checkWidth = () => {
    if (window.innerWidth < 640) {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
  };

  if (!verified) {
    return null;
  }

  return (
    isOpen !== null && (
      <div className={styles.wrapper}>
        <motion.div
          initial={false}
          animate={{ width: isOpen ? "15rem" : "0px" }}
          className={styles.sidebar}
        >
          <Sidebar isOpen={isOpen} />
        </motion.div>
        <motion.div className={styles.main}>
          <Header toggle={toggle} />
          <div className={styles.child__wrapper}>{children}</div>
        </motion.div>
      </div>
    )
  );
};

export default Dashboard;
